import { render, staticRenderFns } from "./FeedbackActions.vue?vue&type=template&id=ef8d6664&scoped=true&"
import script from "./FeedbackActions.vue?vue&type=script&lang=js&"
export * from "./FeedbackActions.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackActions.vue?vue&type=style&index=0&id=ef8d6664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8d6664",
  null
  
)

export default component.exports